var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrict(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "#EFB604"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02539 8.54883C6.42623 8.54883 6.75098 8.87358 6.75098 9.27441C6.75082 9.67511 6.42613 10 6.02539 10C5.62474 9.9999 5.29997 9.67505 5.2998 9.27441C5.2998 8.87364 5.62464 8.54893 6.02539 8.54883ZM6.02734 2C6.22022 2.00003 6.4056 2.06571 6.54199 2.18262C6.67814 2.29942 6.75474 2.45794 6.75488 2.62305V6.98828C6.7548 7.15342 6.67813 7.31187 6.54199 7.42871C6.4056 7.54562 6.22022 7.6113 6.02734 7.61133C5.83442 7.61133 5.64911 7.54564 5.5127 7.42871C5.37647 7.31186 5.29989 7.15347 5.2998 6.98828V2.62305C5.29994 2.45789 5.37646 2.29943 5.5127 2.18262C5.64911 2.06569 5.83442 2 6.02734 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrict);
export default __webpack_public_path__ + "static/media/restrict.003af797ef395977967ccf4abe17a064.svg";
export { ForwardRef as ReactComponent };